import axios from "axios"

export const initializeAxios = () => {
    axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
    axios.defaults.headers["X-Requested-With"] = "XMLHttpRequest"
}
